import React from 'react';

interface Props {
    className?: string;
}

export const SendIcon: React.FC<Props> = ({ className }) => {
    return (
        <svg className={`icon${className ? ` ${className}` : ''}`} width="20" height="20" viewBox="0 0 20 20">
            <path
                d="M18.5,0.1L0.7,6.8c-0.9,0.3-1,1.6-0.1,2.1l7,3.5l3.5,7c0.4,0.9,1.7,0.8,2.1-0.1l6.7-17.7C20.3,0.6,19.4-0.3,18.5,0.1z
                M3.3,8l11.8-4.5l-6.9,6.9L3.3,8z M12,16.7l-2.4-4.9l6.9-6.9L12,16.7z"
            />
        </svg>
    );
};
